// src/content/ui-strings.ts
// ★ Shared UI strings for multilingual support.
// Add keys here for any text that appears in shared components
// (buttons, nav items, footer, etc.).

import type { Language } from '../config/i18n';

/** UI string dictionary — keyed by Language, then by string key */
export const uiStrings: Record<Language, Record<string, string>> = {
    en: {
        // Navigation
        'nav.home': 'Home',
        'nav.about': 'About Us',
        'nav.services': 'Our Services',
        'nav.contact': 'Contact Us',
        'nav.blog': 'Blog',
        'nav.patientPortal': 'Patient Portal',
        'nav.bookAppointment': 'Book Appointment',
        'nav.joinOurTeam': 'Join Our Team',

        // Buttons & CTAs
        'cta.schedule': 'Schedule an Appointment',
        'cta.callNow': 'Call Now',
        'cta.learnMore': 'Learn More',
        'cta.contactUs': 'Contact Us',
        'cta.bookNow': 'Book Now',
        'cta.submit': 'Submit',
        'cta.cancel': 'Cancel',
        'cta.close': 'Close',

        // Common labels
        'label.loading': 'Loading…',
        'label.error': 'Something went wrong',
        'label.phone': 'Phone',
        'label.email': 'Email',
        'label.address': 'Address',
        'label.hours': 'Office Hours',

        // Footer
        'footer.followUs': 'Follow Us',
        'footer.quickLinks': 'Quick Links',
        'footer.contactInfo': 'Contact Information',
        'footer.rights': 'All Rights Reserved',

        // FAQ
        'faq.title': 'Frequently Asked Questions',

        // Table of Contents
        'toc.title': 'On This Page',

        // Trust section
        'trust.title': 'Why Choose Us',
    },

    es: {
        // Navigation
        'nav.home': 'Inicio',
        'nav.about': 'Sobre Nosotros',
        'nav.services': 'Nuestros Servicios',
        'nav.contact': 'Contáctenos',
        'nav.blog': 'Blog',
        'nav.patientPortal': 'Portal del Paciente',
        'nav.bookAppointment': 'Reservar Cita',
        'nav.joinOurTeam': 'Únete a Nuestro Equipo',

        // Buttons & CTAs
        'cta.schedule': 'Programar una Cita',
        'cta.callNow': 'Llamar Ahora',
        'cta.learnMore': 'Más Información',
        'cta.contactUs': 'Contáctenos',
        'cta.bookNow': 'Reservar Ahora',
        'cta.submit': 'Enviar',
        'cta.cancel': 'Cancelar',
        'cta.close': 'Cerrar',

        // Common labels
        'label.loading': 'Cargando…',
        'label.error': 'Algo salió mal',
        'label.phone': 'Teléfono',
        'label.email': 'Correo Electrónico',
        'label.address': 'Dirección',
        'label.hours': 'Horario de Oficina',

        // Footer
        'footer.followUs': 'Síguenos',
        'footer.quickLinks': 'Enlaces Rápidos',
        'footer.contactInfo': 'Información de Contacto',
        'footer.rights': 'Todos los Derechos Reservados',

        // FAQ
        'faq.title': 'Preguntas Frecuentes',

        // Table of Contents
        'toc.title': 'En Esta Página',

        // Trust section
        'trust.title': 'Por Qué Elegirnos',
    },
};
